function attributeCodeToVeeValidateRule (attributeCode, required, number, product) {
  switch (attributeCode) {
    case 'mileage_last_service':
    case 'mileage_cambelt_replaced': {
      if (product?.mileage) {
        const mileage = product?.attributes?.ints?.find(a => a.attributeCode === 'mileage')?.value
        const productMileage = product.mileage
        let mileageRule = ''
        if (mileage) {
          mileageRule = '|max_value:' + mileage
        } else if (productMileage) {
          mileageRule = '|max_value:' + productMileage
        }

        return 'numeric|min_value:1' + mileageRule
      } else {
        return 'numeric|min_value:1'
      }
    }

    case 'length':
      return 'numeric|min_value:1999|max_value:20000'
    case 'trailer_length':
      return 'numeric|min_value:1999|max_value:20000'
    case 'vin':
    case 'trailer_vin':
      return 'length:17'
    case 'mileage':
    case 'trailer_mileage':
      return 'required|numeric|min_value:1'

    case 'power':
      return 'required|min_value:1|max_value:999|numeric'
    case 'engine_capacity':
      return 'required|min_value:100|max_value:9999'
    case 'licensed_weight':
    case 'trailer_licensed_weight':
      return 'min_value:100'
    case 'licensed_seats':
      return 'numeric|min_value:1'
    default: {
      let rule = required ? 'required' : ''
      if (number) {
        rule += '|numeric'
      }
      return rule
    }
  }
}

function backPath (that, productType, slug) {
  return that.localePath({
    name: `ad-edit-${productType}-slug-id`,
    params: { id: that.entityId, slug }
  })
}

function nextPath (that, productType, slug) {
  return that.localePath({
    name: `ad-edit-${productType}-slug-id`,
    params: { id: that.entityId, slug }
  })
}

const moreInformationDamageTypes = {
  GENERAL_DAMAGE: 'GENERAL_DAMAGE',
  GENERAL_DAMAGE_NOT_REPAIRED: 'GENERAL_DAMAGE_NOT_REPAIRED',
  WATER_DAMAGE: 'WATER_DAMAGE',
  WATER_DAMAGE_NOT_REPAIRED: 'WATER_DAMAGE_NOT_REPAIRED',
  HAIL_DAMAGE: 'HAIL_DAMAGE',
  HAIL_DAMAGE_NOT_REPAIRED: 'HAIL_DAMAGE_NOT_REPAIRED'
}

function getMoreInformationRoute () {
  return {
    name: 'ad-edit-motorhome-damage-more-information-id',
    navKey: 'ad.downstream.nav.damage_more_information',
    titleKey: 'ad.downstream.damage_more_information'
  }
}

export default {
  attributeCodeToVeeValidateRule,
  backPath,
  nextPath,
  moreInformationDamageTypes,
  getMoreInformationRoute
}
